// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationModal-cls1_9j4","cls2":"CitationModal-cls2_S4x CitationModal-cls1_9j4"};